<div class="admin-task-details">
  <h2>Prediction Tasks details</h2>
  <button class="btn btn-primary pt-2 pb-2 m-1" (click)="updateTasksDetails()">Refresh</button>
  <table class="table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Status</th>
        <th>Last complete</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (taskDetails of tasksDetails; track taskDetails) {
        <tr>
          <td>{{taskDetails.type}}</td>
          <td>{{taskDetails.status}}</td>
          <td>{{taskDetails.lastComplete}}</td>
          <td>
            @if (taskDetails.status !== 'disabled' && taskDetails.status !== 'multiple') {
              <button type="button" class="btn btn-primary me-1"
                (click)="disableTask(taskDetails.type)">disable
              </button>
            }
            @if (taskDetails.status !== 'idle' && taskDetails.status !== 'multiple') {
              <button type="button" class="btn btn-primary me-1"
                (click)="enableTask(taskDetails.type)">enable
              </button>
            }
            @if (taskDetails.status !== 'multiple') {
              <button type="button" class="btn btn-primary me-1"
                (click)="resetTask(taskDetails.type)">reset
              </button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>